/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import classnames from 'classnames';

export default class TimelineIcon extends React.Component {
  render() {
    const { severity, right } = this.props;

    const iconPosition = { right };
    const iconClassNames = classnames(
      'slds-icon__container',
      'slds-icon_container--circle',
      'timeline-row-impact-icon',
      `timeline-row-impact-icon--${severity}`
    );

    // if minor then `close` icon
    // else major and 'warning' icon
    let url = '';
    if (severity === 'minor') {
      url = '/assets/icons/warning.svg#warning';
    } else if (severity === 'major') {
      url = '/assets/icons/utility-sprite/svg/symbols.svg#close';
    }

    if (severity === 'maintenance') {
      url = '/assets/icons/utility-sprite/svg/symbols.svg#custom_apps';
    } else if (severity === 'informational') {
      url = '/assets/icons/standard-sprite/svg/symbols.svg#announcement';
    }

    return (
      <div className={iconClassNames} style={iconPosition}>
        <svg aria-hidden='true' className='slds-icon slds-icon--small'>
          <use xlinkHref={url}></use>
        </svg>
        <span className='slds-assistive-text'>Impact</span>
      </div>
    );
  }
}
